var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isNewEdition
    ? _c(
        "div",
        { staticClass: "out-wrap" },
        [
          _c(
            "el-container",
            { staticClass: "sen-setting-container" },
            [
              _c(
                "el-aside",
                {
                  staticStyle: { padding: "0 10px 0 0" },
                  attrs: { width: "280px" }
                },
                [
                  _c("el-tree", {
                    ref: "SlotTree",
                    attrs: {
                      data: _vm.setTree,
                      "current-node-key": _vm.currenId,
                      "default-expanded-keys": [_vm.currenId],
                      "default-checked-keys": [_vm.currenId],
                      props: _vm.defaultProps,
                      "expand-on-click-node": false,
                      "highlight-current": true,
                      "node-key": "wordTypeId"
                    },
                    on: { "node-click": _vm.nodeClick },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var node = ref.node
                            var data = ref.data
                            return _c(
                              "div",
                              { staticClass: "comp-tr-node" },
                              [
                                [
                                  _c("div", { staticClass: "template" }, [
                                    _c(
                                      "div",
                                      { staticClass: "comp-tr-node--name" },
                                      [_vm._v(" " + _vm._s(node.label) + " ")]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "comp-tr-node--btns" },
                                      [
                                        node.level == 1 && _vm.senGroupOption
                                          ? _c("el-button", {
                                              attrs: {
                                                icon: "el-icon-plus",
                                                size: "mini",
                                                circle: "",
                                                type: "primary"
                                              },
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                  return _vm.handleAdd(
                                                    node,
                                                    data
                                                  )
                                                }
                                              }
                                            })
                                          : _vm._e(),
                                        node.level != 1 && _vm.senGroupOption
                                          ? _c("el-button", {
                                              attrs: {
                                                icon: "el-icon-edit",
                                                size: "mini",
                                                circle: "",
                                                type: "info"
                                              },
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                  return _vm.handleEdit(
                                                    node,
                                                    data
                                                  )
                                                }
                                              }
                                            })
                                          : _vm._e(),
                                        node.level != 1 && _vm.senGroupOption
                                          ? _c("el-button", {
                                              attrs: {
                                                icon: "el-icon-delete",
                                                size: "mini",
                                                circle: "",
                                                type: "danger"
                                              },
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                  return _vm.handleDel(
                                                    node,
                                                    data
                                                  )
                                                }
                                              }
                                            })
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  ])
                                ]
                              ],
                              2
                            )
                          }
                        }
                      ],
                      null,
                      false,
                      2019596482
                    )
                  })
                ],
                1
              ),
              _c("div", {
                staticStyle: { "border-right": "1px solid #EBEEF5" }
              }),
              _c("el-main", { staticClass: "main-container" }, [
                _c(
                  "div",
                  { staticStyle: { width: "100%", height: "100%" } },
                  [
                    _c(
                      "div",
                      { staticClass: "main-head" },
                      [
                        _c(
                          "el-row",
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 3 } },
                              [
                                _vm.senOption
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          size: "mini",
                                          type: "primary"
                                        },
                                        on: { click: _vm.addNewSen }
                                      },
                                      [_vm._v("添加敏感词")]
                                    )
                                  : _vm._e()
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              {
                                staticStyle: {
                                  float: "right",
                                  "margin-bottom": "5px"
                                },
                                attrs: { span: 3 }
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    size: "mini",
                                    "suffix-icon": "el-icon-search",
                                    placeholder: "敏感词",
                                    clearable: ""
                                  },
                                  on: {
                                    blur: _vm.onInputBlur,
                                    clear: _vm.onInputBlur
                                  },
                                  model: {
                                    value: _vm.getSensiListParams.wordName,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.getSensiListParams,
                                        "wordName",
                                        $$v
                                      )
                                    },
                                    expression: "getSensiListParams.wordName"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      [
                        _c(
                          "el-col",
                          [
                            _c(
                              "el-table",
                              {
                                ref: "cusChatTable",
                                staticStyle: { "font-size": "13px" },
                                attrs: {
                                  size: "small",
                                  data: _vm.tableData,
                                  fit: "",
                                  "highlight-current-row": "",
                                  align: "center",
                                  "header-cell-style": {
                                    background: "#F9F9F9"
                                  },
                                  height: "calc(100vh - 242px)"
                                },
                                on: { "row-click": _vm.handleclick }
                              },
                              [
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "wordName",
                                    label: "敏感词",
                                    "min-width": "150"
                                  }
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "createBy",
                                    label: "操作人",
                                    "min-width": "150"
                                  }
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "createTime",
                                    label: "操作时间",
                                    "min-width": "150"
                                  }
                                }),
                                _vm.senOption
                                  ? _c("el-table-column", {
                                      attrs: {
                                        label: "操作",
                                        "min-width": "100"
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function(scope) {
                                              return [
                                                true
                                                  ? _c(
                                                      "el-button",
                                                      {
                                                        staticClass:
                                                          "table-button",
                                                        attrs: {
                                                          type: "text",
                                                          size: "small"
                                                        },
                                                        nativeOn: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.handleSenDel(
                                                              scope.$index,
                                                              scope.row
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [_vm._v("删除")]
                                                    )
                                                  : _vm._e()
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        false,
                                        860017113
                                      )
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c("Pagination", {
                      attrs: {
                        childMsg: _vm.pageparm,
                        pageSizes: _vm.pageSizes
                      },
                      on: { callBack: _vm.callBack }
                    })
                  ],
                  1
                )
              ])
            ],
            1
          ),
          _c("OptionSenWordType", {
            ref: "OptionSenWordType",
            on: { createSuccess: _vm.createSuccess }
          }),
          _c("addSensitive", {
            ref: "addSensitive",
            on: { addSuccess: _vm.addSuccess }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }